"use strict";
(function (Drupal, once) {
    Drupal.behaviors.openVideoEmbed = {
        attach: function (context) {
            once('openVideoEmbed', '.js-embed-thumbnail', context).forEach(function (element) {
                element.addEventListener('click', function (event) {
                    // Get the video thumbail image
                    const thumbnailImage = element.querySelector('img');
                    // Get the play button
                    const playButton = element.querySelector('.js-play-button');
                    // Check if the video is rendered in the DOM
                    const video = element.querySelector('.js-embed-video');
                    // Get the template tag
                    const templateTag = element.querySelector('template');
                    // If the templateTag is not null
                    if (templateTag != null && video == undefined) {
                        // Clone the template tag
                        const clone = templateTag.content.cloneNode(true);
                        // Append the clone to the element(js-embed-thumbnail)
                        element.appendChild(clone);
                        // Remove scroll from body
                        document.body.style.overflow = 'hidden';
                        // Hide the thumbnail image
                        thumbnailImage === null || thumbnailImage === void 0 ? void 0 : thumbnailImage.classList.add('hidden');
                        // Hide the play button
                        playButton === null || playButton === void 0 ? void 0 : playButton.classList.add('hidden');
                    }
                    else if (video) {
                        // Remove the video
                        video.remove();
                        // Re-add scroll to body
                        document.body.style.overflow = 'auto';
                        // Show the thumbnail image
                        thumbnailImage === null || thumbnailImage === void 0 ? void 0 : thumbnailImage.classList.remove('hidden');
                        // Show the play button
                        playButton === null || playButton === void 0 ? void 0 : playButton.classList.remove('hidden');
                    }
                });
            });
        },
    };
})(Drupal, once);
